<!-- eslint-disable vuetify/no-deprecated-props -->
<template>
  <v-sheet class="category-info-sheet mb-6 wd-z-1" :class="{ 'fill-up': !isIntersectingInfoBox }" color="white">
    <h1 v-if="isTitleBarShown" class="categories__bar d-flex align-center" :class="shouldBannerShow && !hasIntro ? 'mb-2' : 'mb-3'">
      <p class="title-text">{{ region.name }}</p>
      <span class="vertical-divider" />
      <p class="title-text">{{ secondaryTitle || firstLevelCategory.name }}</p>
    </h1>

    <div v-if="hasCategoryInfo" class="info-box">
      <h2 v-if="hasIntro" class="categories__subtitle" :class="shouldBannerShow ? 'wd-mb-2' : 'wd-mb-3'">
        {{ category.intro || firstLevelCategory.intro }}
      </h2>

      <div v-if="shouldShowRegionSearchBar" class="wd-pt-1 wd-pb-4">
        <RegionSearchBar
          :show-category-and-now="false"
          :region="region"
          :search-keywords-of-region="searchKeywordsOfRegion"
          :headcount-options="headcountOptions"
          @update-filter-data="onSearchBarFilterUpdate"
        />
      </div>

      <div v-if="shouldBannerShow" class="wd-mb-3 wd-relative wd-mt-8">
        <BannerSwiperBtnGroup
          v-if="shouldShowSwiperBtns"
          v-show="bannersSwiper?.swiper"
          class="wd-absolute wd-right-0"
          :class="hasIntro ? 'wd--top-9' : 'wd--top-[2.4rem]'"
          :disabled-prev-btn="bannersSwiper?.disabledPrevBtn"
          :disabled-next-btn="bannersSwiper?.disabledNextBtn"
          @prev="bannersSwiper?.prevSwiper()"
          @next="bannersSwiper?.nextSwiper()"
        />
        <BannersSwiper
          ref="bannersSwiper"
          ui-type="category"
          :show-header="false"
          :items="firstLevelCategory.banner || []"
          :is-single-slide-per-view="false"
          :is-image-size-large="true"
        />
      </div>
    </div>

    <!-- 64px is header height -->
    <div v-intersect="{ handler: onIntersect, options: { threshold: 0, rootMargin: '-64px 0px' } }" />
    <!-- subcategory, filter and sort -->
    <div class="filter-box" :class="{ fixed: !isIntersectingInfoBox, subcategoryWithImage: isSubcategoryImageShow && isIntersectingInfoBox }">
      <!-- subcategory -->
      <template v-if="shouldSubcategoryShow">
        <v-tabs
          v-model="currentTabId"
          class="subcategoryTabs"
          :class="{ 'body-container': !isIntersectingInfoBox }"
          color="orange50"
          bg-color="white"
        >
          <v-tab class="subcategoryTab wd-flex wd-flex-col" :value="`${firstLevelCategory.id}`" @click="handleTabClick(firstLevelCategory.id)">
            <img v-if="isSubcategoryImageShow && isIntersectingInfoBox" class="wd-mb-2" :src="getMediaCdnUrl(firstLevelCategory.icon_image)" />
            {{ $t('all_sub_category') }}
          </v-tab>
          <v-tab
            v-for="subcategory in subcategories"
            :key="subcategory.id"
            class="subcategoryTab wd-flex wd-flex-col"
            :value="`${subcategory.id}`"
            @click="handleTabClick(subcategory.id)"
          >
            <img v-if="isSubcategoryImageShow && isIntersectingInfoBox" class="wd-mb-2" :src="getMediaCdnUrl(subcategory.icon_image)" />
            {{ subcategory.name }}
          </v-tab>
        </v-tabs>
      </template>

      <!-- filter and sort -->
      <div class="categories__tools d-flex justify-space-between align-start" :class="{ 'body-container': !isIntersectingInfoBox }">
        <div class="filter-bar d-flex align-center flex-wrap">
          <v-btn
            class="filter-btn"
            :class="{ selected: selectedNowBtn }"
            min-width="100"
            height="40"
            elevation="0"
            variant="outlined"
            @click="updateNowConCondition"
          >
            <FunnowSvgIcon class="mr-2" max-width="24" :image-path="'flash-icon_current.svg'" />
            {{ $t('filter_now') }}
          </v-btn>

          <v-menu
            v-for="(filter, idx) in filterChips"
            :key="filter.name"
            v-model="filterWindowsStatus.chips[idx]"
            :close-on-content-click="false"
            :offset="4"
            location="bottom"
          >
            <template #activator="{ props, value }">
              <v-btn
                :key="filter.name"
                class="filter-btn"
                :class="{ selected: value || filter.activated }"
                min-width="100"
                height="40"
                elevation="0"
                variant="outlined"
                v-bind="props"
              >
                <FunnowSvgIcon v-if="filter.icon" class="mr-2" max-width="24" :image-path="`${filter.icon}.svg`" />
                {{ filter.text || filter.placeholder }}
              </v-btn>
            </template>

            <FilterMenuCard
              v-if="filterWindowsStatus.chips[idx]"
              :clear-btn="filter.clearBtn"
              :sort="sort"
              :index="idx"
              :title="filter.title"
              :filter-key="filter.key"
              :content-type="filter.type"
              :filter-value="filter.value"
              :filter-options="filter.options"
              :current-filter="currentFilter"
              :current-tag-filter="filterTagSettingMap"
              :date-mode="filter.dayMode"
              :total-count="totalCount"
              :filter-selected="filter.activated"
              :key-value="filter.keyValue"
              :menu-width="filter.width"
              :is-branch-card-mode="isBranchCardMode"
              type="chips"
              @confirm="updateCondition"
            />
          </v-menu>

          <v-menu
            v-for="(filter, idx) in filterTags"
            :key="idx"
            v-model="filterWindowsStatus.tags[idx]"
            :close-on-content-click="false"
            :offset="4"
            location="bottom"
          >
            <template #activator="{ props, value }">
              <v-btn
                class="filter-btn"
                :class="{ selected: value || filter.activated }"
                min-width="100"
                height="40"
                elevation="0"
                variant="outlined"
                v-bind="props"
              >
                {{ filter.text || filter.placeholder }}
                <FunnowSvgIcon
                  class="ml-2"
                  max-width="24"
                  :image-path="`chevron-${value ? 'up' : 'down'}${value || filter.activated ? '_orange' : ''}.svg`"
                />
              </v-btn>
            </template>

            <FilterMenuCard
              v-if="filterWindowsStatus.tags[idx]"
              :clear-btn="filter.clearBtn"
              :sort="sort"
              :index="idx"
              :title="filter.title"
              :filter-key="filter.key"
              :content-type="filter.type"
              :filter-value="filter.value"
              :filter-options="filter.options"
              :current-filter="currentFilter"
              :current-tag-filter="filterTagSettingMap"
              :date-mode="filter.dayMode"
              :total-count="totalCount"
              :filter-selected="filter.activated"
              :key-value="filter.keyValue"
              :menu-width="filter.width"
              :is-branch-card-mode="isBranchCardMode"
              type="tags"
              @confirm="updateCondition"
            />
          </v-menu>
        </div>

        <div class="sort-select wd-flex wd-justify-end wd-items-center">
          <p class="mr-1 mb-0">{{ $t('product_list_sorting') }}</p>
          <client-only>
            <!-- 排序選擇 -->
            <v-select
              ref="sortSelect"
              v-model="sort"
              class="sort-select__input"
              :items="sortItems"
              width="192"
              height="40"
              bg-color="white"
              color="orange50"
              item-color="orange50"
              item-title="text"
              item-value="value"
              variant="outlined"
              hide-details
              menu-icon
              @update:model-value="doSort"
            >
              <template #append-inner>
                <FunnowSvgIcon class="!wd-w-6 !wd-h-6" max-width="24" :image-path="'chevron-down.svg'" />
              </template>
              <!-- <template #item="{ item }">
              <p class="my-2">{{ item.title }}</p>
            </template> -->
            </v-select>
            <template #fallback>
              <v-skeleton-loader width="192" height="40" type="ossein" />
            </template>
          </client-only>
        </div>
      </div>
    </div>
  </v-sheet>
</template>

<script>
import { mapGetters } from 'vuex'
import filterSetting from '@/composition/filter-setting'
import utils from '@/utils'
import { CategorySortKey, FilterFromPage } from '@/constants/filters'

import RegionSearchBar from '@/components/page/regions/search-bar.vue'
import { useRegionSearchBarVisibility } from '@/composables/useRegionSearchBarVisibility'
import { useFilterChipsSync } from '@/composables/useFilterChipsSync'

import BannersSwiper from '@/components/swiper/banner-swiper.vue'
import BannerSwiperBtnGroup from '@/components/swiper/BannerSwiperBtnGroup.vue'
import FunnowSvgIcon from '@/components/icons/funnow-svg-icon.vue'

const FilterMenuCard = defineAsyncComponent(() => import('@/components/page/categories/filter-menu-card.vue'))

const getDefaultSortItems = i18n => [
  { text: i18n.t('sort_hot'), value: CategorySortKey.POPULAR },
  { text: i18n.t('sort_price_high_to_low'), value: CategorySortKey.PRICE_HIGH },
  { text: i18n.t('sort_price_low_to_high'), value: CategorySortKey.PRICE_LOW },
]

export default defineComponent({
  name: 'CategoryInfoSheet',
  components: {
    BannersSwiper,
    BannerSwiperBtnGroup,
    FilterMenuCard,
    FunnowSvgIcon,
    RegionSearchBar,
  },
  props: {
    region: { type: Object, default: () => ({}) },
    category: { type: Object, default: () => ({}) },
    subcategoryId: { type: Number, default: 0 },
    dayMode: { type: Number, default: 1 },
    totalCount: { type: Number, default: 0 },
    filters: { type: Object, default: () => ({}) },
    searchKeyWord: { type: String, default: '' },
    hasGeolocation: { type: Boolean, default: false },
    fromPage: { type: String, default: '' },
    hasCategoryInfo: { type: Boolean, default: true },
    isBranchCardMode: { type: Boolean, default: true },
    firstLevelCategoryId: { type: Number, default: 0 },
    tagId: { type: Number, default: null },
    secondaryTitle: { type: String, default: '' },
  },
  emits: ['updateCondition', 'categoryChange'],
  setup(props, { emit }) {
    const {
      sort,
      currency,
      filterChips,
      filterTags,
      filterWindowsStatus,
      currentFilters,
      selectedNowBtn,
      initFilters,
      initSearchFilters,
      initTagFilters,
      getFilterParams,
      fetchSearchKeywords,
      setDataToRenderFilterChips,
      setDataToRenderFilterTags,
      updateFilterCondition,
      clickNowFilter,
      closedMenuValue,
    } = filterSetting(props)

    const nuxtApp = useNuxtApp()
    const i18n = useI18n()

    const sortSelect = ref(null)
    const isIntersectingInfoBox = ref(true)
    const currentTabId = ref(`${props.subcategoryId || 0}`)
    const sortItems = ref(getDefaultSortItems(i18n))
    const bannersSwiper = ref(null)

    const firstLevelCategory = computed(() => nuxtApp.$store.getters['category/firstLevelCategory'])
    const subcategories = computed(() => nuxtApp.$store.getters['category/subcategories'])

    const hasIntro = computed(() => !!(props.category.intro || firstLevelCategory.value.intro))
    // Validate that firstLevelCategory belongs to the current route's category,
    // preventing the old page from mounting BannersSwiper when the Vuex store is
    // updated with new category data during Nuxt Suspense navigation.
    const shouldBannerShow = computed(() => !!firstLevelCategory.value.banner?.length && firstLevelCategory.value.id === props.firstLevelCategoryId)
    const shouldShowSwiperBtns = computed(() => firstLevelCategory.value.banner?.length > 1)

    const shouldSubcategoryShow = computed(() => props.hasCategoryInfo && !props.searchKeyWord && subcategories.value.length > 0)

    const isTitleBarShown = computed(() => props.hasCategoryInfo || !!props.secondaryTitle)

    const { shouldShowRegionSearchBar } = useRegionSearchBarVisibility(
      computed(() => props.filters),
      firstLevelCategory
    )

    watch(
      () => props.hasGeolocation,
      newVal => {
        if (newVal) {
          updateSortItemsWithGeo()
        }
      }
    )

    useFilterChipsSync(currentFilters, setDataToRenderFilterChips, setDataToRenderFilterTags)

    function emitToUpper(filter = {}) {
      emit('updateCondition', { sort: sort.value, filter })
    }

    function doSort() {
      const filterData = getFilterParams()
      emitToUpper(filterData)

      sortSelect.value?.blur()
    }

    function updateSortItemsWithGeo() {
      const defaultSortItems = getDefaultSortItems(i18n)
      defaultSortItems[0].value = CategorySortKey.POPULAR_OVER_DISTANCE

      sortItems.value = [{ text: i18n.t('sort_distance'), value: CategorySortKey.DISTANCE }, ...defaultSortItems]
    }

    return {
      firstLevelCategory,
      subcategories,
      bannersSwiper,
      hasIntro,
      shouldBannerShow,
      shouldShowSwiperBtns,
      shouldSubcategoryShow,
      isTitleBarShown,
      shouldShowRegionSearchBar,
      isIntersectingInfoBox,
      currentTabId,
      sortSelect,
      sort,
      sortItems,
      currency,
      filterChips,
      filterTags,
      filterWindowsStatus,
      currentFilters,
      selectedNowBtn,
      initFilters,
      initSearchFilters,
      initTagFilters,
      getFilterParams,
      fetchSearchKeywords,
      updateFilterCondition,
      updateSortItemsWithGeo,
      clickNowFilter,
      closedMenuValue,
      emitToUpper,
      doSort,
      getMediaCdnUrl: utils.getMediaCdnUrl,
    }
  },
  computed: {
    currentFilter() {
      if (this.$route.query.source_category_id && !this.searchKeyWord) {
        return {
          filter_regionid: this.region.id,
          category_id: this.firstLevelCategory.id,
          sub_category_id: this.subcategoryId,
          filter_keyword: this.searchKeyWord,
          ...this.currentFilters,
        }
      }

      return {
        filter_regionid: this.region.id,
        ...(this.tagId && { filter_tag: `${this.tagId}` }),
        ...(this.firstLevelCategory.id && { category_id: this.firstLevelCategory.id }),
        filter_keyword: this.searchKeyWord,
        ...this.currentFilters,
      }
    },
    isSubcategoryImageShow() {
      return this.subcategories.every(e => !!e.icon_image) && !!this.firstLevelCategory.icon_image
    },
    ...mapGetters({
      filterTagSettingMap: 'filter/filterTags',
      searchKeywordsOfRegion: 'search/searchKeywordsOfRegion',
    }),
    headcountOptions() {
      const components = this.filters?.components || []
      const headcountComp = components.find(c => c.name === 'headcount')
      return headcountComp?.options || []
    },
  },
  watch: {
    filters(newData) {
      if (!newData?.components) return
      this.determineWhichPageAndInitFilters()
    },
  },
  created() {
    this.determineWhichPageAndInitFilters()
  },
  methods: {
    handleTabClick(categoryId) {
      if (categoryId === this.firstLevelCategory.id) {
        this.$emit('categoryChange', this.firstLevelCategory)
        return
      }
      const selectedSubcategory = this.subcategories.find(e => e.id === categoryId)
      if (selectedSubcategory) {
        this.$emit('categoryChange', selectedSubcategory)
      }
    },
    determineWhichPageAndInitFilters() {
      switch (this.fromPage) {
        case FilterFromPage.SEARCH:
          this.initSearchFilters()
          break
        case FilterFromPage.TAG:
          this.initTagFilters()
          break
        default:
          this.initFilters({ hasCusNum: this.category.has_cus_num, hasTimeFilter: this.category.has_time_filter })
          break
      }
    },
    updateNowConCondition() {
      this.clickNowFilter()
      const currentFilterData = this.getFilterParams()
      this.emitToUpper(currentFilterData)
    },
    updateCondition(response) {
      const filterData = this.updateFilterCondition(response)
      this.emitToUpper(filterData)
    },
    onSearchBarFilterUpdate() {
      // Use getFilterParams() instead of the partial `filters` param from the search bar.
      // The search bar emits only the params for the single triggered filter (e.g. just
      // {starttime, endtime} or just {filter_times} or just {limit}), but the store has
      // already been updated synchronously before this event fires. getFilterParams()
      // returns the full merged filter state (all three: date + time + headcount), so the
      // query string built by onConditionUpdate in the page includes all active filters.
      this.emitToUpper(this.getFilterParams())
    },
    onIntersect(isIntersecting, entries, observer) {
      this.isIntersectingInfoBox = isIntersecting
      this.$store.dispatch('setEmbeddedSearchBarVisible', this.shouldShowRegionSearchBar && isIntersecting)

      this.closedMenuValue({ type: 'chips' })
      this.closedMenuValue({ type: 'tags' })
    },
  },
})
</script>

<style scoped lang="scss">
.category-info-sheet {
  position: relative;
  padding: 24px 0 0;
  font-size: 17px;

  &::before {
    content: '';
    width: 100vw;
    height: 100%;
    background: $white;
    position: absolute;
    left: calc(-96px - max(0px, calc(100vw - 1440px) / 2));
    top: 0;
    z-index: -1;
  }
  @include md-down {
    &::before {
      left: -20px;
    }
  }

  &.fill-up {
    padding-bottom: 72px;
  }

  .filter-box {
    &.fixed {
      width: 100vw;
      background-color: white;
      transition: background-color 0.4s;
      box-shadow: 0 10px 10px -5px rgba(0, 0, 0, 0.1);
      position: fixed;
      top: 64px;
      left: 0;
      z-index: 7;
    }

    :deep(.v-tabs-bar) {
      height: 64px;
    }
    &.subcategoryWithImage {
      :deep(.v-tabs-bar) {
        height: 108px;
      }
    }

    .subcategoryTabs {
      margin: auto;
    }
    .subcategoryTab {
      &.v-tab {
        font-size: 17px;
        font-weight: 400;
        text-transform: none;
        letter-spacing: 0;

        &:not(.v-tab--selected) {
          /* to override a tag color */
          color: $black50 !important;
        }
      }

      img {
        width: 36px;
        height: 36px;
      }
    }
  }

  .categories {
    &__bar {
      font-size: 24px;
      font-weight: 700;

      .title-text {
        margin-bottom: 0;
      }

      .vertical-divider {
        height: 16px;
        margin: 0 16px;
        border-right: 1px solid $gray50;
      }
    }

    &__subtitle {
      font-size: 18px;
      font-weight: normal;
    }

    &__tools {
      margin: auto;
      padding: 10px 0;

      .filter-bar {
        margin-left: -6px;
        margin-right: 38px;

        .filter-btn {
          margin: 6px;
          background-color: white;
          border-color: $gray50 !important;
          color: $black50 !important;
          font-size: 17px;

          &.selected {
            border-color: $orange50 !important;
            color: $orange50 !important;
          }
        }
      }

      .sort-select {
        min-width: 265px;
        margin: 6px 0;

        &__input {
          max-width: 192px;
          font-size: 17px;
        }
      }
    }
  }
}
</style>
